<template>
    <div>
        <b-row>
            <b-col sm="12" md="12" lg="12" xl="12">
                <b-card no-body>
                    <b-card-header>
                        <span class="h6">
                            DETALHAMENTO DA AVALIAÇÃO
                        </span>
                    </b-card-header>
                    <b-card-body>
                        <b-row>
                            <b-col sm="12" md="12" lg="12" xl="12">
                                <detalhe titulo="Descrição" :size="size1">
                                    {{ avaliacao.descricao }}
                                </detalhe>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col sm="12" md="12" lg="6" xl="6">
                                <detalhe titulo="Origem" :size="size1">
                                    {{ avaliacao.origem }}
                                </detalhe>                                
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col sm="12" md="12" lg="6" xl="6">
                                <detalhe titulo="Data" :size="size1">
                                    {{avaliacao.dataAvaliacao ? $moment(avaliacao.dataAvaliacao).format('DD/MM/YYYY') : '' }}
                                </detalhe>                                
                            </b-col>
                        </b-row>
                    </b-card-body>
                    <b-card-footer>
                        <b-button class="float-left mr-1" variant="danger" @click.stop="voltar()">
                            <span>
                            <i class="fa fa-history mr-1"></i> Voltar
                            </span>
                        </b-button>
                    </b-card-footer>
                </b-card>
            </b-col>
        </b-row>
        <b-row>
            <b-col sm="12" md="12" lg="12" xl="12">
                <b-card no-body>
                    <b-card-header>
                        <span class="h6">
                            ANEXOS
                        </span>
                    </b-card-header>
                    <b-card-body>
                        <app-tabela
                            :itens="avaliacao.documentos"
                            :campos="campos"
                            :itensPorPagina="itensPorPagina">
                            <template slot="acoes" slot-scope="data">
                                <app-historico-btn-download :documento="data"></app-historico-btn-download>
                            </template>
                        </app-tabela>
                    </b-card-body>
                </b-card>
            </b-col>
        </b-row>
    </div>
</template>

<script>
import BtnDownload from '../btnDownload/btnDownload.vue'
import FiscalizacoesServicos from '../FiscalizacoesServicos'

export default {

    components: {
        AppHistoricoBtnDownload: BtnDownload
    },

    data() {
        return {
            avaliacao: {},
            size1: '150',
            campos: [
                {
                    key: 'nomeArquivo',
                    label: 'Nome do Arquivo',
                    filterable: true,
                    sortable: true,
                },
                {
                    key: 'acoes',
                    label: 'Ações'
                },
            ],
            itensPorPagina: 10,
            listaArquivos: [],
            fiscalizacaoId: null,
            idIrregularidadeFiscalizacao: null,
            idAvaliacaoIrregularidade: null
        }
    },

    computed: {
        combinedProps() {
            return [this.fiscalizacaoId, this.idIrregularidadeFiscalizacao, this.idAvaliacaoIrregularidade];
        },
    },

    methods: {
        voltar() {
            this.$router.push({
                name: `IrregularidadeFiscalizacao_Detalhe`,
                params: {
                    fiscalizacaoId: this.fiscalizacaoId,
                    idIrregularidadeFiscalizacao: this.idIrregularidadeFiscalizacao
                }
            })
        },

        obterAvaliacaoIrregularidadeFiscalizacao(idAvaliacaoIrregularidade) {
            this.$store.dispatch('addRequest')
            FiscalizacoesServicos
                .obterAvaliacaoIrregularidadeFiscalizacao(idAvaliacaoIrregularidade).then(response => {
                if (response) {
                    if (response.success) {
                        this.avaliacao = response.data ? response.data : []
                    } else {
                        this.erros = response.errors
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        },
    },

    watch: {
        combinedProps: {
            handler(newVal) {
                if (newVal.every(val => val !== null && !(Array.isArray(val) && val.length === 0))) {
                    this.obterAvaliacaoIrregularidadeFiscalizacao(this.idAvaliacaoIrregularidade)
                }
            },
            deep: true, // Necessário para observar mudanças nos valores dentro do array
            immediate: true, // Opcional: executa no início
        },
    },

    created() {
        this.fiscalizacaoId = this.$route.params.fiscalizacaoId
        this.idIrregularidadeFiscalizacao = this.$route.params.idIrregularidadeFiscalizacao
        this.idAvaliacaoIrregularidade = this.$route.params.idAvaliacaoIrregularidade
    }

}
</script>